<template>
  <validation-provider
    v-if="validation"
    v-slot="{ errors }"
    rules="required|email"
    name="email"
    tag="div"
  >
    <v-textarea
      height="75"
      type="text"
      dense
      outlined
      hide-details="auto"
      :disabled="disabled"
      :label="label"
      :placeholder="placeholder"
    />
    <transition name="fade">
      <span class="form-field-error" v-if="errors[0]">{{ errors[0] }}</span>
    </transition>
  </validation-provider>
  <v-textarea
    v-else
    height="48"
    type="text"
    dense
    outlined
    hide-details="auto"
    :disabled="disabled"
    :label="label"
    :placeholder="placeholder"
  />
</template>

<script>
export default {
  component: "ApioTextArea",
  props: {
    validation: {
      //field requires validation
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Type here…",
    },
  },
};
</script>
